module.exports = __webpack_public_path__ + "static/media/ship_path_dot.090d4f84.svg";